module.exports = __webpack_public_path__ + "static/media/airgrn.21ca305f.png";